import axios from "axios";
import requestErrorHandler from "./requestErrorHandler";
const token = localStorage.getItem("admin-token-v1");

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    common: { Authorization: `Bearer ${token}` },
  },
});

axiosConfig.interceptors.request.use(
  function (config: any) {
    const token = localStorage.getItem("admin-token-v1");
    // const {token}= useAuth()
    // if (!token) return Promise.reject("unAuthorized");
    const headers: any = {
      Authorization: "Bearer " + token,
    };
    config.headers = headers!;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosConfig.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (
      error.response.status === 401 ||
      error.response?.data?.error === "Not authorized, token failed"
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const fetcher = async (url:string) => {
  try {
    const {data} = await axiosConfig.get(url)
    return data
  } catch (error) {
    requestErrorHandler(error)
  }
}

export const handleMutation = async (url:string, {arg}:{arg: any}) => {
  try {
    const {data} = await axiosConfig.post(url, arg)
    return data
  } catch (error) {
    requestErrorHandler(error)
    throw error;
  }
}

export const handleUpdates = async (url:string, {arg}:{arg: any}) => {
  try {
    const {data} = await axiosConfig.put(url, arg)
    return data
  } catch (error) {
    requestErrorHandler(error)
    throw error;
  }
}

export const handlePatchUpdates = async (url:string, {arg}:{arg: any}) => {
  try {
    const {data} = await axiosConfig.patch(url, arg)
    return data
  } catch (error) {
    requestErrorHandler(error)
    throw error;
  }
}

export default axiosConfig;
